<general-error-message *ngIf="_formService && (_formService.isError$ | async)">
  <span *ngFor="let message of _formService.errors">{{message}}<br/></span>
</general-error-message>
